import { render } from "./XfqcStockTable.vue?vue&type=template&id=e55df49c&scoped=true"
import script from "./XfqcStockTable.vue?vue&type=script&lang=js"
export * from "./XfqcStockTable.vue?vue&type=script&lang=js"

import "./XfqcStockTable.vue?vue&type=style&index=0&id=e55df49c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e55df49c"]])

export default __exports__